import { useBrand } from '../context/BrandContext';
import FastestFormForgotPassword from './fastestform/ForgotPassword';
import AbleForgotPassword from './able/ForgotPassword';

export default function ForgotPassword() {
  const { brand } = useBrand();
  return brand === 'able' ? <AbleForgotPassword /> : <FastestFormForgotPassword />;
}
